import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppFloating } from "./components/WhatsAppButton";
import { Home } from "./pages/Home";
import { ServicePage } from "./pages/ServicePage";
import { LavaJatoPertoDeMim } from "./pages/LavaJatoPertoDeMim";
import { LocalServicePage } from "./pages/LocalServicePage";
import { Sobre } from "./pages/Sobre";
import { Contato } from "./pages/Contato";
import { Galeria } from "./pages/Galeria";
import { AgendamentoWhatsApp } from "./pages/AgendamentoWhatsApp";
import { services, neighborhoods } from "./data/mock";

function App() {
  const slugify = (text) => {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '-');
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            {/* Páginas principais */}
            <Route path="/" element={<Home />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/galeria" element={<Galeria />} />
            <Route path="/agendamento-whatsapp" element={<AgendamentoWhatsApp />} />
            
            {/* Página Lava Jato Perto de Mim */}
            <Route path="/lava-jato-perto-de-mim" element={<LavaJatoPertoDeMim />} />
            
            {/* Páginas de serviços individuais */}
            {services.map(service => (
              <Route 
                key={service.slug} 
                path={`/${service.slug}`} 
                element={<ServicePage />} 
              />
            ))}
            
            {/* Páginas de cidades */}
            <Route path="/lava-jato-goiania" element={<LocalServicePage />} />
            <Route path="/lava-jato-aparecida-de-goiania" element={<LocalServicePage />} />
            <Route path="/estetica-automotiva-goiania" element={<LocalServicePage />} />
            <Route path="/estetica-automotiva-aparecida-de-goiania" element={<LocalServicePage />} />
            
            {/* Páginas híbridas cidade + serviço */}
            <Route path="/lavagem-completa-goiania" element={<LocalServicePage />} />
            <Route path="/lavagem-completa-aparecida-de-goiania" element={<LocalServicePage />} />
            <Route path="/lavagem-detalhada-goiania" element={<LocalServicePage />} />
            <Route path="/lavagem-detalhada-aparecida-de-goiania" element={<LocalServicePage />} />
            <Route path="/detalhamento-automotivo-goiania" element={<LocalServicePage />} />
            <Route path="/detalhamento-automotivo-aparecida-de-goiania" element={<LocalServicePage />} />
            
            {/* Páginas locais por bairro - Lava Jato */}
            {neighborhoods.map(neighborhood => (
              <Route 
                key={`lava-jato-${slugify(neighborhood)}`}
                path={`/lava-jato-${slugify(neighborhood)}`} 
                element={<LocalServicePage />} 
              />
            ))}
            
            {/* Páginas locais por bairro - Estética Automotiva */}
            {neighborhoods.map(neighborhood => (
              <Route 
                key={`estetica-${slugify(neighborhood)}`}
                path={`/estetica-automotiva-${slugify(neighborhood)}`} 
                element={<LocalServicePage />} 
              />
            ))}
            
            {/* Fallback - Redireciona para home */}
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloating />
      </BrowserRouter>
    </div>
  );
}

export default App;
